export default {
  id: 'managing-positions',
  title: 'Managing Open Positions',
  content: `## Managing Open Positions

Once an order fills, it becomes an open position. You can view and manage all open positions from the Orders page.

---

## Where to Find It

**Orders tab → Open Positions** (or Positions tab depending on your layout)

---

## What Each Position Shows

| Field | Description |
|---|---|
| Symbol | Stock name and exchange (NSE) |
| Quantity | Number of shares held |
| Avg Buy Price | Your average cost per share |
| Current Price | Last fetched price |
| Invested Value | Quantity × Avg Buy Price |
| Current Value | Quantity × Current Price |
| Unrealised P&L | Current Value − Invested Value |
| P&L % | Unrealised P&L as a % of Invested Value |
| Trade Type | INTRADAY or DELIVERY |
| Stop Loss | Your set stop price (if configured) |
| Target | Your set target price (if configured) |

---

## Exiting a Position

Tap any open position to view its detail screen. From there:

- **Exit Full Position** — closes all shares at the current market price (Market order)
- **Partial Exit** — specify a quantity to sell only a portion
- **Set / Update Stop Loss** — modify your stop price
- **Set / Update Target** — modify your target price

> Updating your stop loss to a wider level after the trade is moving against you is one of the most common discipline violations. TradeLab tracks this.

---

## Automatic Stop Loss and Target Monitoring

If you set a Stop Loss or Target when placing your order, TradeLab's position monitor runs every minute during market hours (9:15 AM – 3:10 PM IST) and automatically exits the position when the condition is met.

You do not need to watch the screen.

---

## Intraday Auto-Exit at 3:10 PM IST

All positions marked as **INTRADAY** are automatically force-closed at **3:10 PM IST** every trading day, regardless of P&L.

This mirrors the MIS (Margin Intraday Square-off) practice used by Indian brokers. It ensures:
- No unintended overnight exposure on intraday trades
- Consistent end-of-day settlement for practice purposes

DELIVERY positions are not affected by the 3:10 PM auto-exit and hold overnight.

---

## Viewing P&L on a Position

Unrealised P&L updates every time the price feed refreshes — prices update every few seconds during market hours.

Once you exit a position, it moves from Open Positions to **Trade History** and the P&L becomes realised.

---

## Position Limits

| Property | Value |
|---|---|
| Max open positions | No hard limit |
| Overnight holding | Allowed for DELIVERY trades |
| Intraday exit deadline | 3:10 PM IST |
| Minimum position size | No hard minimum |`,
};
